import { render, staticRenderFns } from "./ClassExam.vue?vue&type=template&id=8c78e0a6&scoped=true&"
import script from "./classexam.js?vue&type=script&lang=js&"
export * from "./classexam.js?vue&type=script&lang=js&"
import style0 from "./ClassExam.vue?vue&type=style&index=0&id=8c78e0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c78e0a6",
  null
  
)

export default component.exports